import { GetServerSidePropsContext } from 'next'
import { setCookie } from 'nookies'
import { CheckoutFlow } from '../../flow/type'

export const FLOW_COOKIE_NAME = 'apt-flow-name'

export enum FlowCookieValue {
  Default = 'default',
  ApplePaylater = 'apple-paylater',
}

const FLOW_TO_COOKIE_VALUE: Record<CheckoutFlow, FlowCookieValue> = {
  default: FlowCookieValue.Default,
  'apple-paylater': FlowCookieValue.ApplePaylater,
}

const COOKIE_VALUE_TO_FLOW: Record<FlowCookieValue, CheckoutFlow> = {
  [FlowCookieValue.Default]: 'default',
  [FlowCookieValue.ApplePaylater]: 'apple-paylater',
}

export const getFlowFromCookie = (context: GetServerSidePropsContext): CheckoutFlow | null => {
  const flowCookie = context.req.cookies[FLOW_COOKIE_NAME] as FlowCookieValue | undefined

  if (!flowCookie) {
    return null
  }

  return COOKIE_VALUE_TO_FLOW[flowCookie] ?? null
}

export const setFlowCookie = (context: GetServerSidePropsContext, flow: CheckoutFlow): void => {
  const cookieValue = FLOW_TO_COOKIE_VALUE[flow]

  setCookie(context, FLOW_COOKIE_NAME, cookieValue, {
    maxAge: 60 * 60,
    secure: process.env.NODE_ENV === 'production',
    path: '/',
    sameSite: 'lax',
  })
}
